<template>
  <div>
    <div @click="nodeClicked" :style="{'margin-left': `${depth * 20}px`}"
         class="node cursor d-flex justify-content-between">
      <div class="left">


        <span v-if="hasChildren">{{ expanded ? '&#9866;' : '&#10010;' }}</span>
        <span :id="node.id"
              class="titleHover"
              :class="{'highlightCategory': node.id === $store.state.selectedCategory,
              'bg-danger': node.state === 'I',
              'bg-warning': node.state !== 'A' && node.state !== 'I'
              }">
          {{ node.code }} {{ node.title }}
        </span>
      </div>
      <div class="right">
        <span class="text-success" v-if="node.children_count === 0">[{{ node.products_count }}]</span>
        <span v-if="node.children_count > 0">[{{ node.children_count }}]</span>
      </div>
    </div>
    <template v-if="expanded" >
      <TreeBrowser
          :notValidatedActions="notValidatedActions"
          v-for="(child, key) in node.children"
          :node="child"
          :depth="depth + 1"
          @onClick="touchParent"
          @actionData="(action) => $emit('actionData',action)"
          :key="key"
      />
    </template>
    <div :style="{'margin-left': `${depth * 25}px`}">
      <notValidatedActions
          v-if="expanded"
          :notValidatedActions="notValidatedActions"
          :selectedAction="selectedAction"
          @actionClick="actionClick"
      ></notValidatedActions>
    </div>
    </div>
</template>

<script>
import {GET} from "@/shared/api";
import notValidatedActions from "@/views/allLogic/common/notValidatedActions";

export default {
  name: "TreeBrowser",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0
    },
  },
  components: {notValidatedActions},
  data() {
    return {

      notValidatedActions: {
        type: Array,
        default: () => {
          return [];
        },
      },
      selectedAction: {},
      expanded: false,
      selected: null
    };
  },
  methods: {

    getCategoryActions(node) {
      if (node.id) {
        GET([], "/category/query/" + node.id + "?mode=actions", this, false).then(response => {
          let result = response;

          result.forEach((val, index) => {
            val.request_data = JSON.parse(val.request_data);
            val.route = JSON.parse(val.route);
            if (typeof val.user == 'undefined' || val.user == null) {
              val.user = {
                name: null
              }
            }
            if (typeof val.action === 'undefined' || val.action === null) {
              val.action = {
                action: null,
                user: {
                  name: null
                }
              }
            }
          });
          this.notValidatedActions = result;
        });
      }
    },
    actionClick(obj) {
      this.selectedAction = obj.action;
      this.selectedAction.index = obj.index;
      this.nodeClicked(null)
      this.giveActionToParent(this.selectedAction);
    },
    touchParent(node) {
      this.notValidatedActions = [];
      this.$emit('onClick', node);
    },
    giveActionToParent(action){
      this.$emit('actionData', action);

    },
    nodeClicked(event) {
      if (event === null){
        this.$store.state.selectedCategory = null;
      }else {
        this.expanded = !this.expanded;
        this.$store.state.selectedCategory = this.node.id;
        this.getCategoryActions(this.node);
        this.removeAllClasses();
        this.$emit("onClick", this.node);
      }
    },
    removeAllClasses() {
      var elements = document.getElementsByClassName('highlightCategory');
      for (let i = 0; i < elements.length; i++) {
        if (this.$store.state.selectedCategory !== this.node.id) {
          elements[i].classList.remove('highlightCategory');
        }
      }
    }
  },
  computed: {
    hasChildren() {
      return this.node.hasChildren;
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
.node {
  text-align: left;
}
</style>
